<template>
  <div>
    <div class="row mb-3">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.incrementType') }}
      </label>
      <div class="col-md-7">
        <Select
          v-model="model.increment_type"
          :currency="defaultCurrencySign"
        >
          <Option value="%">%</Option>
          <Option :value="defaultCurrencySign">
            {{ defaultCurrencySign }}
          </Option>
        </Select>
        <div class="validate ts-text-xs" v-if="errors.has('increment_type')">
          {{ errors.first('increment_type') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.incrementAmount') }}
      </label>
      <div class="col-md-7">
        <input
          v-model="model.increment_amount"
          type="number"
          class="form-control"
        />
        <div class="validate ts-text-xs" v-if="errors.has('increment_amount')">
          {{ errors.first('increment_amount') }}
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh mt-3">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>

        <ts-button color="primary" @click.prevent="onUpdate" :waiting="waiting">
          {{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { isEmpty } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'product-price-schema-edit',
  data () {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
        increment_type: null,
        increment_amount: null
      }
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('restaurantSale/productPriceSchema', ['edit_data']),

    defaultCurrencySign () {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    }
  },
  methods: {
    onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('restaurantSale/productPriceSchema/update', {
          id: this.edit_data.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async setEditData () {
      if (!isEmpty(this.edit_data)) {
        this.model.increment_type = this.edit_data.increment_type
        this.model.increment_amount = this.edit_data.increment_amount
      }
    },
    clearInput () {
      this.model.increment_type = null
      this.model.increment_amount = null
    }
  },
}
</script>
